import * as hpServicesApi from "../../api/healthPlanServicesApi";
import * as types from "../../constants/actionTypes";
import { call, put, select } from "redux-saga/effects";
import { logAPI } from "../../api/andyliticsApi";

export function* getClaims(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    const memid = domainData.aai || domainData.hi || sessionData.healthPlanUserProfile.memberUserClaims.memberHccId;

    if (stateData.aalDown === false) {
        try {
            const response = yield call(hpServicesApi.ClaimsApi.getClaimsList, domainData.t, memid, params.startDate, params.endDate); //t = access token, aai = American Airlines id
            logAPI("MBHWeb.Saga.HealthPlanServices.Claims.GetClaimsList.Get", start, null);
            yield put({ type: types.HP_GET_CLAIMS_LIST_SUCCESS, claims: response, isFetching: false });

            //if (domainData && !domainData.hpt && domainData.t && domainData.aai) {
            //    const response = yield call(getClaimsList, domainData.t, domainData.aai); //t = access token, aai = American Airlines id
            //    logAPI("MBHWeb.Saga.WebTPA.Claims.GetClaimsList.Get", start, null);
            //    yield put({ type: types.HP_GET_CLAIMS_LIST_SUCCESS, claims: response, isFetching: false });
            //} else if (domainData && domainData.hpt && domainData.hpid) {

            //}
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Claims.GetClaimsList.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_CLAIMS_LIST_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Claims.GetClaimsList.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getClaimDetails(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    const memid = domainData.aai || domainData.hi || sessionData.healthPlanUserProfile.memberUserClaims.memberHccId;

    if (stateData && stateData.aalDown === false) {
        try {
            //if (domainData && domainData.t && domainData.aai) {
            //const response = yield call(getClaimDetail, domainData.t, domainData.aai, params.claimId); //t = access token, aai = American Airlines id
            const response = yield call(hpServicesApi.ClaimsApi.getClaimDetail, domainData.t, memid, params.claimId); //t = access token, aai = American 
            logAPI("MBHWeb.Saga.HealthPlanServices.Claims.GetClaimDetail.Get", start, null);
            yield put({ type: types.HP_GET_CLAIM_DETAIL_SUCCESS, claimDetail: response, isFetching: false });
            //}
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Claims.GetClaimDetail.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_CLAIM_DETAIL_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Claims.GetClaimDetail.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* submitClaimAppeal(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);

    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData && domainData.t) {//Bug-34585
                const response = yield call(hpServicesApi.ClaimsApi.submitClaimAppeal, domainData.t, params.relatedClaims, params.relatedMembers, params.relatedUserAccountName, params.description); //t = access token, aai = American Airlines id
                logAPI("MBHWeb.Saga.HealthPlanServices.Claims.SubmitClaimAppeal.Get", start, null);
                yield put({ type: types.HP_SUBMIT_CLAIM_APPEAL_SUCCESS, success: response.success, issueId: response.issueId, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Claims.SubmitClaimAppeal.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_SUBMIT_CLAIM_APPEAL_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Claims.SubmitClaimAppeal.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}